<div
  class="flex flex-col items-start justify-start h-fit w-full rounded bg-[#E3E9F2] p-8 gap-8 min-[1024px]:rounded-lg min-[1024px]:p-12 min-[1024px]:gap-0"
>
  <!-- Mobile: heading centered row, Desktop: heading in col container -->
  <div
    class="flex flex-row items-center justify-center w-full gap-4 min-[1024px]:flex-col min-[1024px]:items-start min-[1024px]:justify-start min-[1024px]:gap-8"
  >
    <!-- Heading -->
    <div
      class="flex flex-col items-center justify-center h-fit w-fit min-[1024px]:items-start min-[1024px]:w-full"
    >
      <h3
        class="flex flex-wrap items-start justify-start h-fit w-fit text-[#161C23] text-3xl font-semibold tracking-[-0.75px] leading-9 text-left min-[1024px]:w-full min-[1024px]:text-4xl min-[1024px]:tracking-[-0.9px] min-[1024px]:leading-10"
      >
        {{ title() }}
      </h3>
    </div>

    <!-- Desktop: two-column list container (hidden on mobile since heading is separate) -->
    <div class="hidden min-[1024px]:flex flex-row items-start justify-start h-fit w-full gap-6">
      <!-- Left List -->
      <div class="flex flex-col items-start justify-start h-fit w-full gap-6">
        @for (item of desktopLeftItems(); track $index) {
          <div class="flex flex-row items-start justify-start h-fit w-full gap-4">
            <div class="flex flex-col items-start justify-start pt-1 pb-0 h-fit w-fit">
              <span
                class="text-black font-bold text-lg leading-7 tracking-normal text-left h-[28px] w-[7px]"
                >/</span
              >
            </div>
            <div class="flex flex-col items-start justify-start h-fit w-fit">
              <span
                class="text-[#474747] font-normal text-lg leading-[29.25px] tracking-normal text-left"
                >{{ item }}</span
              >
            </div>
          </div>
        }
      </div>
      <!-- Right List -->
      <div class="flex flex-col items-start justify-start h-fit w-full pb-6">
        @for (item of desktopRightItems(); track $index) {
          <div class="flex flex-row items-start justify-start h-fit w-full gap-4">
            <div class="flex flex-col items-start justify-start pt-1 pb-0 h-fit w-fit">
              <span
                class="text-black font-bold text-lg leading-7 tracking-normal text-left h-[28px] w-[7px]"
                >/</span
              >
            </div>
            <div class="flex flex-col items-start justify-start h-fit w-fit">
              <span
                class="text-[#474747] font-normal text-lg leading-[29.25px] tracking-normal text-left"
                >{{ item }}</span
              >
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Mobile: full list (hidden on desktop) -->
  <div class="flex flex-col items-center justify-center h-fit w-full gap-6 min-[1024px]:hidden">
    @for (item of items(); track $index) {
      <div class="flex flex-row items-start justify-center h-fit w-full gap-4 max-w-[540px]">
        <div class="flex flex-col items-start justify-start pt-1 pb-0 h-fit w-fit">
          <span
            class="text-black font-bold text-lg leading-7 tracking-normal text-left h-[28px] w-[7px]"
            >/</span
          >
        </div>
        <div class="flex flex-col items-start justify-start h-fit w-fit">
          <span
            class="text-[#474747] font-normal text-base leading-[26px] tracking-normal text-left"
            >{{ item }}</span
          >
        </div>
      </div>
    }
  </div>
</div>
